window.addEventListener('load', function() {
	// console.log("Test");
	// BounceX tag -- Speed Optimization Trick
  // (function(d) {
  //   var e = d.createElement('script');
  //   e.src = d.location.protocol + '//tag.bounceexchange.com/3733/i.js';
  //   e.async = true;
  //   d.getElementsByTagName("head")[0].appendChild(e);
  // }(document));

	function loadScript(id, url, callback) {
    	let script = document.getElementById(id);
    	script.src = url;
    	script.onload = () => callback();
 	}

 	function loadCss(filename) {
 		var fileref = document.createElement("link");
    	fileref.setAttribute("rel", "stylesheet");
    	fileref.setAttribute("type", "text/css");
    	fileref.setAttribute("href", filename);
    	document.getElementsByTagName("head")[0].appendChild(fileref)
 	}

  setTimeout(function(){
    // Load Findify -- Speed Optimization
  	loadScript('findify-assets','https://findify-assets-2bveeb6u8ag.netdna-ssl.com/search/prod/kassatex.myshopify.com.min.js', script => {});

  	const $popupTemplate = $('.popup-promotion');
    if (localStorage.getItem('promotion_result_set_header') == 'true') {
      var announcement_text = localStorage.getItem('promotion_result_set_header_template');
      if ($('.header__bar .shell').length > 0) {
        $('.header__bar .shell').html(announcement_text);

        if ($('.header-checkout').length > 0 ) {
          $('.header-checkout').css({
            'margin-top': "30px"
          });
          $('.header__bar').css({
            'height': '30px'
          });
        }
      }
    } else {
      $('.header-checkout .header__bar').remove();
    }
	}, 50);

});